package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.NotificationSettings
import com.example.readingnotes.domain.repository.NotificationRepository
import com.example.readingnotes.util.Result

class GetNotificationSettingsUseCase(
    private val repository: NotificationRepository,
) {
    suspend operator fun invoke(): Result<NotificationSettings> = repository.getSettings()
}

class UpdateNotificationSettingsUseCase(
    private val repository: NotificationRepository,
) {
    suspend operator fun invoke(settings: NotificationSettings): Result<NotificationSettings> =
        repository.updateSettings(settings)
}

class GetNotificationsUseCase(
    private val repository: NotificationRepository,
) {
    suspend operator fun invoke(
        limit: Int,
        offset: Int,
        unreadOnly: Boolean,
    ): Result<com.example.readingnotes.domain.model.PaginatedNotifications> =
        repository.getNotifications(limit, offset, unreadOnly)
}

class MarkNotificationAsReadUseCase(
    private val repository: NotificationRepository,
) {
    suspend operator fun invoke(id: String): Result<Boolean> = repository.markAsRead(id)
}

class MarkAllNotificationsAsReadUseCase(
    private val repository: NotificationRepository,
) {
    suspend operator fun invoke(): Result<Int> = repository.markAllAsRead()
}
